import axios from "axios";
import fetch from "../utils/fetch";
import { createMessage, returnErrors } from "./messages";

// GET REGISTER CODE
export const fetchCode = (mobile, code_type) => (dispath) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = JSON.stringify({ mobile, code_type });

  axios
    .post("/api/verifications/fetch_sms_code", body, config)
    .then((res) => {
      if (res.data.isOperateSuccess) {
        dispath(
          createMessage({
            fetchCodeSuccess: res.data.message,
            task_id: res.data.task_id,
          })
        );
      } else {
        dispath(createMessage({ fetchCodeFail: res.data.message }));
      }
    })
    .catch((err) => {
      dispatch(returnErrors(err.response.data, err.response.status));
    });
};

// GET REGISTER EMAIL CODE
export const fetchEmailCode = (email, username) => (dispath) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  const body = JSON.stringify({ email, username });

  axios
    .post("/api/verifications/fetch_email_code", body, config)
    .then((res) => {
      if (res.data.isOperateSuccess) {
        dispath(
          createMessage({
            fetchCodeSuccess: res.data.message,
            task_id: res.data.task_id,
          })
        );
      } else {
        dispath(createMessage({ fetchCodeFail: res.data.message }));
      }
    })
    .catch((err) => {
      dispatch(returnErrors(err.response.data, err.response.status));
    });
};


// 获取邮箱验证码
export function getEmailCode(data) {
  return fetch({
    url: "/api/verifications/fetch_email_code",
    method: "post",
    data: data
  });
}